import React, { Component } from 'react';
import { loadScript } from '../Base/Async';

export default (WrappedComponent, libraries) => {
  return class withGoogleMapsAPI extends Component {
    shouldLoadMapsApi = typeof window !== 'undefined' && typeof google === 'undefined';

    state = {
      googleMapsAPIIsLoading: true,
      isError: false,
      google: null,
    };

    componentDidMount() {
      const pwtMapsIsReady = () => {
        this.setState({
          googleMapsAPIIsLoading: false,
          google: window.google,
        });
      };
      window.pwtMapsIsReady = pwtMapsIsReady.bind(this);

      if (!this.shouldLoadMapsApi) {
        pwtMapsIsReady();
        return;
      }

      const { mapApiKey } = this.props;
      loadScript(
        'pwt-googlemaps-script',
        `https://maps.googleapis.com/maps/api/js?key=${mapApiKey}${libraries}&callback=pwtMapsIsReady`,
        (error) => {
          if (error) {
            this.setState({
              googleMapsAPIIsLoading: false,
              isError: true,
            });
            return;
          }
        }
      );
    }

    render() {
      return <WrappedComponent {...this.props} {...this.state} />;
    }
  };
};
